// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.flex-col {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.header {
  display: flex;
  justify-content: space-between;
  margin: 1em auto;
}
.header h3 {
  margin: 0;
}
@media screen and (max-width: 780px) {
  .header {
    align-items: flex-start;
    flex-direction: column-reverse;
  }
  .header .header-buttons {
    margin: 1rem 0;
  }
}

:host ::ng-deep .priority-2,
:host ::ng-deep .priority-3,
:host ::ng-deep .visibility-sm {
  display: none;
}

@media screen and (max-width: 767px) {
  :host ::ng-deep .visibility-sm {
    display: flex;
    flex-direction: column;
    margin-left: 2rem;
  }
  .table-col {
    width: 30%;
  }
  .table-col.lg {
    width: 70%;
  }
}
@media screen and (min-width: 768px) {
  :host ::ng-deep .priority-2 {
    display: table-cell;
  }
  :host ::ng-deep .priority-3 {
    display: table-cell;
  }
  .table-col {
    width: 10%;
  }
  .table-col.lg {
    width: 70%;
  }
  .table-col.sm {
    width: 10%;
  }
}
@media screen and (min-width: 1024px) {
  .table-col {
    width: 20%;
  }
  .table-col.lg {
    width: 50%;
  }
  .table-col.sm {
    width: 10%;
  }
}
@media screen and (min-width: 1280px) {
  :host ::ng-deep .priority-3 {
    display: table-cell;
  }
  .table-col {
    width: 10%;
  }
  .table-col.lg {
    width: 40%;
  }
  .table-col.sm {
    width: 5%;
  }
}
.subscriptionLine {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.zero {
  text-align: center;
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./projects/app-ui/src/app/admin/pages/marketing/subscriptions/subscriptions.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,SAAA;AACJ;;AAEA;EACI,aAAA;EACA,8BAAA;EACA,gBAAA;AACJ;AACI;EACI,SAAA;AACR;AAEI;EATJ;IAUQ,uBAAA;IACA,8BAAA;EACN;EACM;IACI,cAAA;EACV;AACF;;AAGA;;;EAGI,aAAA;AAAJ;;AAGA;EACI;IACI,aAAA;IACA,sBAAA;IACA,iBAAA;EAAN;EAGE;IACI,UAAA;EADN;EAGM;IACI,UAAA;EADV;AACF;AAKA;EACI;IACI,mBAAA;EAHN;EAKE;IACI,mBAAA;EAHN;EAME;IACI,UAAA;EAJN;EAMM;IACI,UAAA;EAJV;EAOM;IACI,UAAA;EALV;AACF;AASA;EAEI;IACI,UAAA;EARN;EAUM;IACI,UAAA;EARV;EAWM;IACI,UAAA;EATV;AACF;AAaA;EACI;IACI,mBAAA;EAXN;EAcE;IACI,UAAA;EAZN;EAcM;IACI,UAAA;EAZV;EAeM;IACI,SAAA;EAbV;AACF;AAiBA;EACI,aAAA;EACA,mBAAA;EACA,WAAA;AAfJ;;AAkBA;EACI,kBAAA;AAfJ;AACA,o1GAAo1G","sourcesContent":[".flex-col {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n}\n\n.header {\n    display: flex;\n    justify-content: space-between;\n    margin: 1em auto;\n\n    h3 {\n        margin: 0;\n    }\n\n    @media screen and (max-width: 780px) {\n        align-items: flex-start;\n        flex-direction: column-reverse;\n\n        .header-buttons {\n            margin: 1rem 0;\n        }\n    }\n}\n\n:host ::ng-deep .priority-2,\n:host ::ng-deep .priority-3,\n:host ::ng-deep .visibility-sm {\n    display: none;\n}\n\n@media screen and (max-width: 767px) {\n    :host ::ng-deep .visibility-sm {\n        display: flex;\n        flex-direction: column;\n        margin-left: 2rem;\n    }\n\n    .table-col {\n        width: 30%;\n\n        &.lg {\n            width: 70%;\n        }\n    }\n}\n\n@media screen and (min-width: 768px) {\n    :host ::ng-deep .priority-2 {\n        display: table-cell;\n    }\n    :host ::ng-deep .priority-3 {\n        display: table-cell;\n    }\n\n    .table-col {\n        width: 10%;\n\n        &.lg {\n            width: 70%;\n        }\n\n        &.sm {\n            width: 10%;\n        }\n    }\n}\n\n@media screen and (min-width: 1024px) {\n\n    .table-col {\n        width: 20%;\n\n        &.lg {\n            width: 50%;\n        }\n\n        &.sm {\n            width: 10%;\n        }\n    }\n}\n\n@media screen and (min-width: 1280px) {\n    :host ::ng-deep .priority-3 {\n        display: table-cell;\n    }\n\n    .table-col {\n        width: 10%;\n\n        &.lg {\n            width: 40%;\n        }\n\n        &.sm {\n            width: 5%;\n        }\n    }\n}\n\n.subscriptionLine {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n}\n\n.zero {\n    text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
